import {
  AuthenticationApiRemoteService,
  TPasswordResetValidateResponse,
} from '../../Services/api/auth/service-authentication'
import { Result } from '../../Shared/Protocol/protocol-result'

export class ValidatePasswordResetTokenUseCase {
  constructor(private readonly authApi: AuthenticationApiRemoteService) {}

  public async handle(token: string): Promise<Result<TPasswordResetValidateResponse>> {
    try {
      return await this.authApi.validatePasswordResetToken(token)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
